import React, { useState, useEffect } from 'react';
import './CardRating.css';
import axios from 'axios';
import { Button, Tooltip, OverlayTrigger  } from 'react-bootstrap';

const CardRating = ({ cardid, initialRating = 0, totalVotes = 0, userRated = 0 }) => {
  const [rating, setRating] = useState(userRated);
  const [hoverRating, setHoverRating] = useState(0);
  const [currentTotalVotes, setCurrentTotalVotes] = useState(totalVotes);
  const [currentInitialRating, setCurrentInitialRating] = useState(initialRating);

    useEffect(() => {
      setHoverRating(0);
      setRating(userRated);
      setCurrentTotalVotes(totalVotes);
      setCurrentInitialRating(initialRating);
    }, [cardid]);
  
  const handleClick = async (newRating) => {
    try {
      const response = await axios.post('/api/card/vote.php', { id: cardid, rate: newRating });
	  setRating(newRating);
	  setCurrentTotalVotes(response.data.votes);
	  setCurrentInitialRating(response.data.rating);
    } catch (error) {
      console.error('Error submitting rating:', error);
    }
  };

  const handleMouseEnter = (index) => {
    setHoverRating(index);
  };

  const handleMouseLeave = () => {
    setHoverRating(0);
  };

  const renderTooltip = props => (
    <Tooltip {...props}>Cards need at least 4 votes until they can have rating and can enter the Gallery.</Tooltip>
  );

  return (
    <div className="rating-card align-items-center">
      {[1, 2, 3, 4, 5].map((index) => (
        <Star
          key={index}
          index={index}
          rating={hoverRating || rating}
          onClick={() => handleClick(index)}
          onMouseEnter={() => handleMouseEnter(index)}
          onMouseLeave={handleMouseLeave}
        />
      ))}
{currentTotalVotes < 4 ?
  <span className="indicator mx-1">{`${currentTotalVotes}/4`}</span> :
  <span className="indicator mx-1">{`${currentInitialRating}`}</span>
}
{currentTotalVotes < 4 &&
      <OverlayTrigger placement="top" overlay={renderTooltip}>
        <Button variant="link">?</Button>
      </OverlayTrigger>
}

	  </div>
  );
};

const Star = ({ index, rating, onClick, onMouseEnter, onMouseLeave }) => {
  return (
    <span
      className={`star ${index <= rating ? 'filled' : ''}`}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      ★
    </span>
  );
};

export default CardRating;
